<div class="content">
    <div>
        <div class="access-denied-message">
            Access denied<br>
            please contact ________ for access
        </div>
    </div>
</div>
